import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AgencyRequestRoutingModule } from './agency-request-routing.module';
import { AgencyRequestComponent } from './agency-request.component';
import { AgencyConfigInfo } from './agency-request-field-config';
import { CoreInputsModule } from '@tmhcc-ng-lib/framwork/core-inputs';

@NgModule({
  declarations: [AgencyRequestComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreInputsModule,
    AgencyRequestRoutingModule
  ]
})
export class AgencyRequestModule {}
